import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class QuotaService {
	
  async getQuotaById(quotaId: string) {
	return await Api().get(`${API_URL}/quota/${quotaId}`, { headers:  authHeader() as any });      
  }
  async find(term: string) {
    return await Api().get(`${API_URL}/quota/find?text=${term}%`, { headers:  authHeader() as any });      
  }

  async updateQuota(quota: any) {
    return await Api().put(`${API_URL}/quota/${quota.id}`, quota, 
    { method: 'PUT',
      headers:  authHeader() as any });      
  }

  async createQuota(quota: any) {
    return await Api().post(`${API_URL}/quota/`, quota, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async deleteQuota(quota: any) {
    return await Api().delete(`${API_URL}/quota/${quota.id}`, 
    { method: 'DELETE',
      headers:  authHeader() as any });      
  }  

  async getMetadata() {
    return await Api().get(`${API_URL}/quota/metadata`, { headers:  authHeader() as any });      
  }
}

export default new QuotaService();